import { useEffect } from 'react';

// Extend the Window interface to include embeddedservice_bootstrap
declare global {
    interface Window {
        embeddedservice_bootstrap?: any
        initEmbeddedMessaging: () => void;
    }
}
const EmbeddedMessaging = () => {
  useEffect(() => {
    console.log("Initializing Salesforce Embedded Messaging...");
    console.log("Salesforce Embedded Messaging configuration:", {
      orgId: process.env.REACT_APP_SF_ORG_ID,
      deploymentName: process.env.REACT_APP_SF_DEPLOYMENT_NAME,
      deploymentUrl: process.env.REACT_APP_SF_DEPLOYMENT_URL,
      scrtUrl: process.env.REACT_APP_SF_SCRT_URL,
      bootstrapUrl: process.env.REACT_APP_SF_BOOTSTRAP_URL,
    });
    if(!process.env.REACT_APP_SF_ORG_ID || !process.env.REACT_APP_SF_DEPLOYMENT_NAME || !process.env.REACT_APP_SF_DEPLOYMENT_URL || !process.env.REACT_APP_SF_SCRT_URL || !process.env.REACT_APP_SF_BOOTSTRAP_URL) {
      console.error("Salesforce Embedded Messaging is not properly configured.");
        return;
    }
    const initScript = document.createElement('script');
    initScript.type = 'text/javascript';
    initScript.text = `
      function initEmbeddedMessaging() {
      console.log("Initializing initEmbeddedMessaging...");
        try {
          embeddedservice_bootstrap.settings.language = 'fr';
          embeddedservice_bootstrap.settings.displayHelpButton = false;
          embeddedservice_bootstrap.init(
            '${process.env.REACT_APP_SF_ORG_ID}',
            '${process.env.REACT_APP_SF_DEPLOYMENT_NAME}',
            '${process.env.REACT_APP_SF_DEPLOYMENT_URL}',
            {
              scrt2URL: '${process.env.REACT_APP_SF_SCRT_URL}'
            }
          );
        } catch (err) {
          console.error('Error loading Embedded Messaging: ', err);
        }
      };
    `;
    document.body.appendChild(initScript);

    const bootstrapScript = document.createElement('script');
    bootstrapScript.type = 'text/javascript';
    bootstrapScript.src = process.env.REACT_APP_SF_BOOTSTRAP_URL;
    bootstrapScript.onload = () => {
      if (typeof window.initEmbeddedMessaging === 'function') {
        window.initEmbeddedMessaging();
      }
    };

    document.body.appendChild(bootstrapScript);

    return () => {
      console.log("Cleaning up Salesforce Embedded Messaging scripts...");
       window.embeddedservice_bootstrap?.removeMarkup()
      document.body.removeChild(initScript);
      document.body.removeChild(bootstrapScript);
    };
  }, []);

  return null; // No visual element needed
};

export default EmbeddedMessaging;
